<template>
  <div>
    <div class="add-to-cart">
      <button type="submit" name="submit">
        <i>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 21">
            <path
              d="M21.7 8.2c-.1.3-.3.7-.5 1.1-.8 1.7-1.7 3.4-2.8 5-.4.5-1 1.4-1.6 1.5-.5.2-1.4 0-1.9 0-1.8 0-3.9.1-5.7 0-1.4-.1-2.4-.7-3.1-1.4-.8-.8-1-1.9-1.3-3.2-.3-1.8-.7-3.8-1-5.7-.3-1-.3-2.1-1.1-2.5-.8-.5-2.1.1-2.6-.9V.9C.5 0 2.3.3 3.2.6c.6.2 1.2.4 1.6.8C6 2.6 6.1 4.8 6.5 6.7c.2.9.4 1.9.6 2.9.3 1.3.3 3 1.4 3.5.8.4 2.3.2 3.6.2H14c.6 0 1.4.1 1.9 0 .4-.1 1-1.3 1.2-1.6.7-1.2 1.3-2.3 1.9-3.6.3-.6.6-1.4 1.2-1.5 1-.1 1.7.6 1.5 1.6zm-8.5 1.4c-.1.1-.4.4-.6.4-.5 0-.9-.7-1.2-1-.7-.8-1.4-1.5-2-2.3-.2-.1-.8-.7-.8-1.1.1-.7 1.5-.2 2.3-.4.1-1.2.1-2.5.3-3.7.5-.6 2.2-.5 2.7 0 .1 1.2.2 2.4.2 3.7.7.1 2.2-.3 2.3.3.1.4-.6 1.1-.8 1.3-.7 1-1.5 1.9-2.4 2.8zm-4.7 7.1c1.4-.2 2.3.7 2.4 1.6.4 2.5-2.8 3.1-3.8 1.4-.9-1.4.2-2.8 1.4-3zm7.4 0c1.3-.2 2.4.7 2.4 2s-1 2-1.9 2.1c-1.3.1-2.2-.9-2.2-2.1 0-1.1.8-1.9 1.7-2z"
              fill="#fff"
            />
          </svg>
        </i>
        <span class="screen-reader-text--archive">{{ translations.addToCart }}</span>
      </button>
    </div>

    <div class="loader" v-if="isLoading">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
form {
   .loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(54, 54, 54, 0.315);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 9rem;
    height: 3rem;
  }
  .lds-ellipsis div {
    position: absolute;
    top: 35%;
    width: 1.3rem;
    height: 1.3rem;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 0.8rem;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 0.8rem;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 3.2rem;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 5.6rem;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(2.4rem, 0);
    }
  }
}
</style>
<script>
export default {
  name: "KaaliAddToCart",
  props: {
    isLoading: Boolean
  },
  data() {
    return {
      translations: {
        addToCart: ws_vue_store.translations.add_to_cart
      }
    };
  }
};
</script>
